import { createSlice } from '@reduxjs/toolkit'

import api, { createWrappedAsyncThunk } from 'src/api'

export const initialState = {
  conversation: null,
  conversations: [],
}

const SLICE_NAME = 'messages'

const getUrlRoot = ({ getState }) => {
  const { user } = getState().auth
  const { type } = user.organisation
  return `/${type}`
}

export const sendMessage = createWrappedAsyncThunk(
  `${SLICE_NAME}/sendMessage`,
  (arg, thunkApi) =>
    api.post(`${getUrlRoot(thunkApi)}/conversations/`, { body: arg })
)

export const sendReply = createWrappedAsyncThunk(
  `${SLICE_NAME}/sendReply`,
  ({ id, text }, thunkApi) =>
    api.post(`${getUrlRoot(thunkApi)}/conversations/${id}/messages/`, {
      body: { text },
    })
)

export const fetchUnreadConversationsCount = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchUnreadConversationsCount`,
  (section, thunkApi) =>
    api.get(`${getUrlRoot(thunkApi)}/conversations/unread_count/`)
)

export const fetchConversations = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchConversations`,
  (section, thunkApi) =>
    api.get(`${getUrlRoot(thunkApi)}/conversations/${section}/`)
)

export const fetchSingleConversation = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchSingleConversation`,
  (id, thunkApi) =>
    api.get(`${getUrlRoot(thunkApi)}/conversations/${id}/messages/`)
)

export const markConversationRead = createWrappedAsyncThunk(
  `${SLICE_NAME}/markConversationRead`,
  ({ id, messageIds }, thunkApi) =>
    api.post(`${getUrlRoot(thunkApi)}/conversations/${id}/mark_read/`, {
      body: { messageIds },
    })
)

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchConversations.fulfilled]: (state, { payload }) => {
      state.conversations = payload
      return state
    },
    [fetchSingleConversation.fulfilled]: (state, { payload }) => {
      state.conversation = payload
      return state
    },
    [sendReply.fulfilled]: (state, { payload }) => {
      if (state.conversation.id === payload.id) {
        state.conversation = payload
      }
      return state
    },
    [markConversationRead.fulfilled]: (state, { payload }) => {
      return state
    },
  },
})

export default slice.reducer
